import Vue from 'vue'
import { Pagination, Dialog, Select, Tree, Button, Switch } from 'element-ui'

Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Select)
Vue.use(Tree)
Vue.use(Button)
Vue.use(Switch)
